import { useEffect, useState } from 'react';

/**
 * Returns true on narrow / coarse-pointer / touch devices.
 * Only enables the mobile branch — desktop behavior stays 100% unchanged.
 *
 * Detection is done SSR-safely via a getter that reads matchMedia once
 * on mount and listens for orientation / breakpoint changes.
 */
export const useIsMobile = (query = '(max-width: 768px)') => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(query);
    const coarse = window.matchMedia('(pointer: coarse)');
    const compute = () => setIsMobile(mq.matches || coarse.matches);
    compute();
    mq.addEventListener?.('change', compute);
    coarse.addEventListener?.('change', compute);
    return () => {
      mq.removeEventListener?.('change', compute);
      coarse.removeEventListener?.('change', compute);
    };
  }, [query]);

  return isMobile;
};

export default useIsMobile;
